import PropTypes from 'prop-types';
import React from 'react';
import en from '../../intl/translations/en';

const ChartRangeSelectorCTA = ({ href, onClickPaywall }) => (
  <div className="sl-chart-range-selector-cta">
    <div className="sl-chart-range-selector-cta__text">
      {en.premiumCTA.ChartRangeSelectorCTA.mainText}
    </div>
    <div className="sl-chart-range-selector-cta__action">
      <a href={href} onClick={onClickPaywall} className="sl-chart-range-selector-cta__action__link">
        {en.premiumCTA.ChartRangeSelectorCTA.linkText}
      </a>
    </div>
  </div>
);

ChartRangeSelectorCTA.defaultProps = {
  onClickPaywall: null,
  href: null,
};

ChartRangeSelectorCTA.propTypes = {
  onClickPaywall: PropTypes.func,
  href: PropTypes.string,
};

export default ChartRangeSelectorCTA;
